// Module access constants for subscription-based access control
export const MODULE_ACCESS = {
  // Available to all plans
  DASHBOARD: 'dashboard',
  DATA_MANAGEMENT: 'data_management',
  ESG_REPORTING: 'esg_reporting',
  RISK_MANAGEMENT: 'risk_management',
  CARBON_ACCOUNTING: 'carbon_accounting',
  PORTFOLIO: 'portfolio',
  NET_ZERO: 'net_zero',
  SUPPLY_CHAIN: 'supply_chain',
  
  // Corporate and Enterprise only
  ORGANIZATION_TEAM_MANAGEMENT: 'organization_team_management',
  
  // Enterprise only
  CLIMATE_RISK_ASSESSMENT: 'climate_risk_assessment',
  // Individual and above
  DOUBLE_MATERIALITY_ASSESSMENT: 'double_materiality_assessment',
} as const;

export const MODULE_DISPLAY_NAMES = {
  [MODULE_ACCESS.DASHBOARD]: 'Dashboard',
  [MODULE_ACCESS.DATA_MANAGEMENT]: 'Data Management',
  [MODULE_ACCESS.ESG_REPORTING]: 'ESG Reporting',
  [MODULE_ACCESS.RISK_MANAGEMENT]: 'Risk Management',
  [MODULE_ACCESS.CARBON_ACCOUNTING]: 'Carbon Accounting',
  [MODULE_ACCESS.PORTFOLIO]: 'Portfolio Assessment',
  [MODULE_ACCESS.NET_ZERO]: 'Net Zero Planning',
  [MODULE_ACCESS.SUPPLY_CHAIN]: 'Supply Chain Assessment',
  [MODULE_ACCESS.ORGANIZATION_TEAM_MANAGEMENT]: 'Organization & Team Management',
  [MODULE_ACCESS.CLIMATE_RISK_ASSESSMENT]: 'Climate Risk Assessment',
  [MODULE_ACCESS.DOUBLE_MATERIALITY_ASSESSMENT]: 'Double Materiality Assessment',
} as const;

export const PLAN_FEATURES = {
  BASIC: {
    modules: [
      MODULE_ACCESS.DASHBOARD,
      MODULE_ACCESS.DATA_MANAGEMENT,
    ],
    excluded_modules: [
      MODULE_ACCESS.ESG_REPORTING,
      MODULE_ACCESS.RISK_MANAGEMENT,
      MODULE_ACCESS.CARBON_ACCOUNTING,
      MODULE_ACCESS.PORTFOLIO,
      MODULE_ACCESS.NET_ZERO,
      MODULE_ACCESS.SUPPLY_CHAIN,
      MODULE_ACCESS.ORGANIZATION_TEAM_MANAGEMENT,
      MODULE_ACCESS.CLIMATE_RISK_ASSESSMENT,
      MODULE_ACCESS.DOUBLE_MATERIALITY_ASSESSMENT,
    ],
    max_collaborators: 0,
    support: 'email',
    dedicated_support: false,
    more_collaborators_on_demand: false,
  },
  INDIVIDUAL: {
    modules: [
      MODULE_ACCESS.DASHBOARD,
      MODULE_ACCESS.DATA_MANAGEMENT,
      MODULE_ACCESS.ESG_REPORTING,
      MODULE_ACCESS.RISK_MANAGEMENT,
      MODULE_ACCESS.CARBON_ACCOUNTING,
      MODULE_ACCESS.PORTFOLIO,
      MODULE_ACCESS.NET_ZERO,
      MODULE_ACCESS.SUPPLY_CHAIN,
      MODULE_ACCESS.DOUBLE_MATERIALITY_ASSESSMENT,
    ],
    excluded_modules: [
      MODULE_ACCESS.CLIMATE_RISK_ASSESSMENT,
      MODULE_ACCESS.ORGANIZATION_TEAM_MANAGEMENT,
    ],
    max_collaborators: 1,
    support: 'email',
    dedicated_support: false,
    more_collaborators_on_demand: false,
  },
  CORPORATE: {
    modules: [
      MODULE_ACCESS.DASHBOARD,
      MODULE_ACCESS.DATA_MANAGEMENT,
      MODULE_ACCESS.ESG_REPORTING,
      MODULE_ACCESS.RISK_MANAGEMENT,
      MODULE_ACCESS.CARBON_ACCOUNTING,
      MODULE_ACCESS.PORTFOLIO,
      MODULE_ACCESS.NET_ZERO,
      MODULE_ACCESS.SUPPLY_CHAIN,
      MODULE_ACCESS.ORGANIZATION_TEAM_MANAGEMENT,
      MODULE_ACCESS.DOUBLE_MATERIALITY_ASSESSMENT,
    ],
    excluded_modules: [
      MODULE_ACCESS.CLIMATE_RISK_ASSESSMENT,
    ],
    max_collaborators: 1,
    support: 'priority',
    dedicated_support: false,
    more_collaborators_on_demand: false,
  },
  ENTERPRISE: {
    modules: [
      MODULE_ACCESS.DASHBOARD,
      MODULE_ACCESS.DATA_MANAGEMENT,
      MODULE_ACCESS.ESG_REPORTING,
      MODULE_ACCESS.RISK_MANAGEMENT,
      MODULE_ACCESS.CARBON_ACCOUNTING,
      MODULE_ACCESS.PORTFOLIO,
      MODULE_ACCESS.NET_ZERO,
      MODULE_ACCESS.SUPPLY_CHAIN,
      MODULE_ACCESS.ORGANIZATION_TEAM_MANAGEMENT,
      MODULE_ACCESS.CLIMATE_RISK_ASSESSMENT,
      MODULE_ACCESS.DOUBLE_MATERIALITY_ASSESSMENT,
    ],
    excluded_modules: [],
    max_collaborators: 10,
    support: 'dedicated',
    dedicated_support: true,
    more_collaborators_on_demand: true,
  },
} as const; 
